import { render } from "./Button.vue?vue&type=template&id=6d57b57e&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=6d57b57e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hapi/hapi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d57b57e"]])

export default __exports__